import { render, staticRenderFns } from "./CommunicationNavigation.vue?vue&type=template&id=75fe72b6&scoped=true"
import script from "./CommunicationNavigation.vue?vue&type=script&lang=ts"
export * from "./CommunicationNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fe72b6",
  null
  
)

export default component.exports